module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/CatSad-011d9c34930b411b85960ff588538d8d.png";